import { Directive, ElementRef, Renderer2, HostListener, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

const MIN_WIDTH = 244.6;

@Directive({
  selector: '[appRenderWidth]'
})
export class RenderWidthDirective {

  constructor(private element: ElementRef, private renderer: Renderer2, @Optional() @Self() private ngControl: NgControl) { }

  ngOnInit() {
    if (this.ngControl) {
      // Access to control
      const control = this.ngControl.control;

      // When control change
      control?.valueChanges.subscribe(() => {
        this.renderWidth();
      });

      // Valid control
      if (control) {
        // Mark Control
        control.markAsTouched();
      }
    }
  }

  ngAfterContentInit() {
    // After init the component
    this.renderWidth();
  }

  private renderWidth() {
    let nativeElement = this.element.nativeElement;
    let value = nativeElement.value;

    if (nativeElement.nodeName === "SELECT") {
      let index = nativeElement.selectedIndex;
      if (index != -1) {
        value = nativeElement.options[index].innerHTML;
      } else {
        value = "";
      }
    }

    const mirror = document.getElementById("mirror");


      mirror!.textContent = value;
      mirror!.style.font = nativeElement.font;
      let newWidth = mirror!.offsetWidth + 25;
      if (newWidth < MIN_WIDTH) newWidth = MIN_WIDTH;

      this.renderer.setStyle(this.element.nativeElement, 'width', `${newWidth}px`);



  }
}
